// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upgrade-bee-tier-container {
  position: relative;
}
.upgrade-bee-tier-container > div {
  animation: fadein 0.5s ease-in-out;
}
.upgrade-bee-tier-container .back-button {
  position: absolute;
  top: 40px;
  margin: 0;
  left: 40px;
  cursor: pointer;
  color: #2a2a2a;
  font-size: 16px;
  font-weight: 700;
  transition: 0.3s ease-in-out;
}
.upgrade-bee-tier-container .back-button:hover {
  color: var(--primary-color-1);
}
.upgrade-bee-tier-container .broker-container {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  align-items: center;
  width: 100%;
  padding: 10px 15px;
  border-radius: 5px;
  background: var(--primary-color-1);
  border: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.upgrade-bee-tier-container .broker-container:hover {
  opacity: 0.75;
}
.upgrade-bee-tier-container .broker-container .broker-image {
  width: 25px;
  height: 25px;
  object-fit: cover;
  border: 3px solid white;
  border-radius: 50px;
  margin-right: 10px;
}
.upgrade-bee-tier-container .broker-container .broker-info {
  color: white;
  font-weight: 700;
  font-size: 16px;
  margin: 0;
}
.upgrade-bee-tier-container .filepond--root {
  margin-bottom: 0;
}
.upgrade-bee-tier-container .filepond--panel-root {
  border-radius: 16px !important;
  background-color: transparent !important;
}
.upgrade-bee-tier-container .filepond--drop-label {
  background: #F9F9F9 !important;
  height: 120px;
  border-radius: 16px;
}
.upgrade-bee-tier-container .filepond--credits {
  display: none;
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/BeeTier/modules/UpgradeForm/upgradeForm.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAAI;EACI,kCAAA;AAER;AAAI;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AAER;AAAQ;EACI,6BAAA;AAEZ;AACI;EACI,aAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AACR;AAAQ;EACI,aAAA;AAEZ;AAAQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAEZ;AAAQ;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;AAEZ;AACI;EACI,gBAAA;AACR;AACI;EACI,8BAAA;EACA,wCAAA;AACR;AACI;EACI,8BAAA;EACA,aAAA;EACA,mBAAA;AACR;AACI;EACI,aAAA;AACR;AACI;EACI;IAAO,UAAA;EAEb;EADM;IAAO,UAAA;EAIb;AACF","sourcesContent":[".upgrade-bee-tier-container {\r\n    position: relative;\r\n    > div {\r\n        animation: fadein 0.5s ease-in-out;\r\n    }\r\n    .back-button {\r\n        position: absolute;\r\n        top: 40px;\r\n        margin: 0;\r\n        left: 40px;\r\n        cursor: pointer;\r\n        color: #2a2a2a;\r\n        font-size: 16px;\r\n        font-weight: 700;\r\n        transition: 0.3s ease-in-out;\r\n\r\n        &:hover {\r\n            color: var(--primary-color-1);\r\n        }\r\n    }\r\n    .broker-container {\r\n        display: flex;\r\n        width: fit-content;\r\n        align-items: center;\r\n        width: 100%;\r\n        padding: 10px 15px;\r\n        border-radius: 5px;\r\n        background: var(--primary-color-1);\r\n        border: 5px;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        cursor: pointer;\r\n        &:hover {\r\n            opacity: .75;\r\n        }\r\n        .broker-image {\r\n            width: 25px;\r\n            height: 25px;\r\n            object-fit: cover;\r\n            border: 3px solid white;\r\n            border-radius: 50px;\r\n            margin-right: 10px;\r\n        }\r\n        .broker-info {\r\n            color: white;\r\n            font-weight: 700;\r\n            font-size: 16px;\r\n            margin: 0;\r\n        }\r\n    }\r\n    .filepond--root {\r\n        margin-bottom: 0;\r\n    }\r\n    .filepond--panel-root {\r\n        border-radius: 16px !important;\r\n        background-color: transparent !important;\r\n    }\r\n    .filepond--drop-label{\r\n        background: #F9F9F9 !important;\r\n        height: 120px;\r\n        border-radius: 16px;\r\n    }\r\n    .filepond--credits {\r\n        display: none;\r\n    }\r\n    @keyframes fadein {\r\n        from { opacity: 0; }\r\n        to   { opacity: 1; }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
